import { GET_LODGING_POLICIES_FAILURE, GET_LODGING_POLICIES_REQUEST, GET_LODGING_POLICIES_SUCCESS, GetLodgingPoliciesActionTypes, GetLodgingPoliciesState } from './types';

const defaultState: GetLodgingPoliciesState = {
  isLoading: false,
  errorMessage: "",
};

export default function getLodgingPolicies(state = defaultState, action: GetLodgingPoliciesActionTypes): GetLodgingPoliciesState {
  switch (action.type) {
    case GET_LODGING_POLICIES_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GET_LODGING_POLICIES_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case GET_LODGING_POLICIES_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};
